/*
 * @Author: long
 * @Date: 2021-11-03 14:48:49
 * @LastEditTime: 2023-12-08 09:15:30
 * @LastEditors: long
 * @Description:
 * @FilePath: /website/Users/long/Documents/workspace/components/directive/index.js
 *
 */

function checkPermission(el, value) {
  const systemCode = sessionStorage.getItem("systemCode");
  const permission = sessionStorage.getItem("permission");
  const treeList = JSON.parse(permission);
  if (!treeList) {
    setTimeout(() => {
      checkPermission(el, value);
    }, 1000);
  }
  if (treeList) {
    const treeMap = treeList[systemCode];
    if (treeMap && Array.isArray(value) && value.length === 2) {
      const menu = treeMap[value[0]];
      if (menu) {
        const hasPermission = menu[value[1]];
        if (!hasPermission) {
          el.parentNode && el.parentNode.removeChild(el);
        }
        console.warn(`${value.toString()}-${hasPermission}`);
      } else {
        el.parentNode && el.parentNode.removeChild(el);
      }
    } else {
      el.parentNode && el.parentNode.removeChild(el);
    }
  }
}

const directive = {
  name: "button",
  hooks: {
    inserted(el, { value }) {
      return checkPermission(el, value);
    },
    updated(el, { value }) {
      return checkPermission(el, value);
    },
  },
};

const install = function (Vue) {
  Vue.directive(directive.name, directive.hooks);
};

directive.install = install;

export default directive;
